<template>
    <div class="topnav-user-profile-loader">
        <ContentLoader
            :height="radius * 2"
            :width="radius * 2"
            :speed="speed"
            :primaryColor="primaryColor"
            :secondaryColor="secondaryColor"
            :animate="animate"
            :style="`height: ${radius * 2}px`"
        >
            <circle :cx="radius" :cy="radius" :r="radius" />
        </ContentLoader>
    </div>
</template>

<script lang="ts">
    import { Component, Mixins } from 'vue-property-decorator';
    import { ContentLoader } from 'vue-content-loader';
    import ContentLoaderMixin from '@/common/mixins/content-loader';

    @Component({
        components: { ContentLoader },
    })
    export default class TopNavigationUserProfileContentLoader extends Mixins(ContentLoaderMixin) {
        public radius = 20;
    }
</script>

<style lang="less" scoped>
    .topnav-user-profile-loader {
        display: flex;
        align-items: center;
        max-height: @core-header-height;
        mix-blend-mode: multiply;
    }
</style>
